import React from 'react';
import { Link } from 'react-router-dom';
import ColourSwatchGrid from '../ColourSwatchGrid';
import { SAULEDA_COLOURS, STOCK_COLOUR_CODE, TOTAL_COLOURWAYS } from '../../data/sauledaColours';
import './ColourCollection.css';

// The full awning fabric range, shown as the supplied colour chart. Sits under
// the awnings showcase so the range flows straight into "and here are the
// colours you can have it in".
//
// Rendered from data/sauledaColours.js via the shared swatch grid, so the
// homepage, the colours page and the product-page swatches cannot disagree.
export default function ColourCollection() {
  return (
    <section className="asg-colours" id="fabric-colours">
      <div className="asg-colours-inner">
        <div className="asg-colours-header asg-reveal">
          <p className="asg-section-label">Fabric Colours</p>
          <h2 className="asg-section-title">Every colourway, in one place.</h2>
          <p className="asg-colours-sub">
            Spanish Sauleda acrylic in {TOTAL_COLOURWAYS} colourways. Charcoal grey is held in
            stock; every other colourway is made to order.
          </p>
        </div>

        {/* The range rendered from the same data as the colours page and the
            product-page swatches. It used to be a static image with the SKU
            codes printed on it, which went stale the moment a code changed. */}
        <div className="asg-colours-figure asg-reveal">
          <ColourSwatchGrid colours={SAULEDA_COLOURS} stockCode={STOCK_COLOUR_CODE} />
          <p className="asg-colours-note">
            Colours shown are a guide only - screens vary. Ask us for the exact shade before
            you order.
          </p>
        </div>

        <div className="asg-colours-actions asg-reveal">
          <Link to="/products/awnings" className="asg-btn-secondary">See the awning range</Link>
        </div>
      </div>
    </section>
  );
}
